import { useState } from 'react';
import TableCell from '@mui/material/TableCell';
import {
  Box,
  Chip,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { NoMaxWidthTooltip } from '../../NoMaxWidthTooltip';
import { Save, Close, Edit } from '@mui/icons-material';

export interface ColorTypographyCellProps {
  align?: 'left' | 'center' | 'right' | 'inherit' | 'justify' | undefined;
  text?: string;
  subtext?: string;
  color?: 'error' | 'warning';
  tooltip?: string;
  onEdit?: Function;
}

export const ColorTypographyCell = ({
  align,
  text,
  subtext,
  color,
  tooltip,
  onEdit,
}: ColorTypographyCellProps) => {
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [value, setValue] = useState<string>(text || '');
  const [prevValue, setPrevValue] = useState<string>(text || '');
  const [hover, setHover] = useState<boolean>(false);
  if (isEditing) {
    return (
      <Box>
        <TextField
          size="small"
          onClick={event => {
            event.stopPropagation();
            event.preventDefault();
          }}
          InputProps={{
            sx: {
              fontSize: '1rem',
              fontWeight: 500,
            },
            endAdornment: (
              <InputAdornment position="end">
                <Tooltip title={'Save'}>
                  <IconButton
                    size="small"
                    sx={{ zIndex: 1 }}
                    onClick={event => {
                      event.stopPropagation();
                      event.preventDefault();
                      setPrevValue(value);
                      onEdit && onEdit(value);
                      setIsEditing(false);
                    }}
                  >
                    <Save fontSize="small" />
                  </IconButton>
                </Tooltip>

                <Tooltip title={'Cancel'}>
                  <IconButton
                    size="small"
                    sx={{ zIndex: 1 }}
                    onClick={event => {
                      event.stopPropagation();
                      event.preventDefault();
                      setValue(prevValue);
                      setIsEditing(false);
                      setHover(false);
                    }}
                  >
                    <Close fontSize="small" />
                  </IconButton>
                </Tooltip>
              </InputAdornment>
            ),
          }}
          value={value}
          onChange={event => {
            setValue((pv: any) => event.target.value);
          }}
        />
      </Box>
    );
  } else {
    return (
      <NoMaxWidthTooltip
        title={tooltip || ''}
        sx={{
          whiteSpace: 'pre-line',
        }}
      >
        <Box
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          sx={onEdit ? { cursor: 'pointer', display: 'flex' } : {}}
        >
          <Typography
            variant="body2"
            sx={{
              color: theme => (color ? theme.palette[color].main : 'inherit'),
              whiteSpace: 'pre-line',
            }}
          >
            {text}
            {subtext && (
              <span>
                &nbsp;<small>{subtext}</small>
              </span>
            )}
          </Typography>
          {onEdit && (
            <Tooltip title={'Edit title'}>
              <IconButton
                size="small"
                sx={
                  hover
                    ? { zIndex: 1, p: 0, ml: 2 }
                    : { zIndex: 1, visibility: 'hidden', p: 0, ml: 2 }
                }
                onClick={event => {
                  event.stopPropagation();
                  event.preventDefault();
                  setPrevValue(value);
                  setIsEditing(true);
                }}
              >
                <Edit fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </NoMaxWidthTooltip>
    );
  }
};
